
import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'
import CardDetailsForm from '@/components/onboarding/CardDetailsForm.vue'
import BundleCard from '@/components/wizard/BundleCard.vue'
import PhoneForm from '@/components/wizard/PhoneForm.vue'
import { RButton } from '@/components'
import { bundleSummary, getBundleButtonText } from '@/services/bundles'
import { BundlePreset, BundleWorkstationTableColumn, WorkstationType } from '@/store/types/config'
import { BundlePeriod } from '@/api/types/user'
import BundleCardSpecsTable from '@/components/wizard/BundleCardSpecsTable.vue'
import { workstationsColumnsWithPrices } from '@/services/workstations'
import { WorkstationDetailsModal } from '@/components/modals'

type BundleAddCardData = {
  stateBundle: BundlePreset
  showSpecsWithDiscountsModal: boolean
  detailsExpanded: boolean
}

export default Vue.extend({
  name: 'BundleAddCard',
  components: {
    CardDetailsForm,
    BundleCard,
    RButton,
    PhoneForm,
    BundleCardSpecsTable,
    WorkstationDetailsModal,
  },
  data(): BundleAddCardData {
    return {
      stateBundle: this.bundle,
      showSpecsWithDiscountsModal: false,
      detailsExpanded: false,
    }
  },
  props: {
    bundle: {
      type: Object as PropType<BundlePreset>,
    },
    variant: {
      type: String as PropType<'mobile' | 'desktop'>,
      default: 'mobile',
    },
    bundlePeriod: {
      type: String as PropType<BundlePeriod>,
    },
  },
  computed: {
    ...mapGetters({
      isPaymentDataValid: 'payment/isPaymentValid',
      setupRequest: 'user/setupRequest',
      workstationTypes: 'config/workstationTypes',
      bundles: 'config/bundles',
      trialEndSecondsTimestamp: 'user/trialEndSecondsTimestamp',
    }),
    buttonText(): string {
      return getBundleButtonText(this.stateBundle)
    },
    isButtonDisabled(): boolean {
      return !this.isPaymentDataValid
    },
    isButtonSpinning(): boolean {
      return this.setupRequest.pending
    },
    /**
     * The button default styles must be overriden
     */
    buttonStyle(): { [key: string]: number | string } {
      if (!this.isButtonDisabled && !this.isButtonSpinning) {
        return { backgroundColor: 'limeGreen', color: 'var(--textAlternate)' }
      }
      return {}
    },
    summary(): Object {
      const bundleName = this.stateBundle.name
      return bundleSummary[bundleName]
    },
    errorMessage(): string {
      if (this.setupRequest.failed) {
        return this.setupRequest.error
      }
      return ''
    },
    getAvailableWorkstations(): WorkstationType[] {
      return this.workstationTypes
    },
    proBundle(): BundlePreset {
      return this.bundles.find((bundle: BundlePreset) => bundle.codename === 'pro-2022-01')
    },
    columns(): BundleWorkstationTableColumn[] | null {
      //on freelancer bundle we would like to show pro bundle discounts
      const bundle = this.stateBundle.codename.includes('freelancer')
        ? this.proBundle
        : this.stateBundle
      return workstationsColumnsWithPrices(bundle, this.getAvailableWorkstations)
    },
    showFreelancerPrice(): boolean {
      return !this.bundle.codename.includes('freelancer')
    },
    isDesktop(): boolean {
      return this.variant === 'desktop'
    },
    showTrialInfo(): boolean {
      return !this.trialEndSecondsTimestamp
    },
  },
  methods: {
    goPro(): void {
      this.stateBundle = this.proBundle
    },
    handleDiscountClick(): void {
      this.detailsExpanded = true
    },
    handleButtonClick(): void {
      this.$emit('change-bundle', this.stateBundle)
      this.$emit('finalize')
    },
  },
})
